export default __webpack_public_path__ + "images/4a125ed94057ac112d2273e070c51141.png";